import React, { useState } from 'react';
import { Outlet } from 'react-router-dom';
import {
  AppBar,
  Box,
  IconButton,
  Toolbar,
  Typography,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import AppIcon from '../common/AppIcon';
import Sidebar, { DRAWER_WIDTH } from './Sidebar';
import SettingsDialog from '../common/SettingsDialog';

export interface AppOutletContext {
  refreshKey: number;
}

const AppLayout: React.FC = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [settingsOpen, setSettingsOpen] = useState(false);
  const [refreshKey, setRefreshKey] = useState(0);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  return (
    <Box sx={{ display: 'flex', minHeight: '100vh', bgcolor: 'grey.50' }}>
      <Sidebar
        open={sidebarOpen}
        onClose={() => setSidebarOpen(false)}
        onOpenSettings={() => setSettingsOpen(true)}
      />
      <Box
        sx={{
          flexGrow: 1,
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        {isMobile && (
          <AppBar
            position="sticky"
            elevation={0}
            sx={{ bgcolor: 'background.paper', borderBottom: '1px solid', borderColor: 'grey.200' }}
          >
            <Toolbar>
              <IconButton edge="start" onClick={() => setSidebarOpen(true)} sx={{ color: 'grey.800' }}>
                <AppIcon name="menu" />
              </IconButton>
              <Typography variant="h6" sx={{ color: 'primary.main', fontWeight: 700 }}>
                Wedding CC
              </Typography>
            </Toolbar>
          </AppBar>
        )}
        <Box
          component="main"
          sx={{
            flexGrow: 1,
            pt: { xs: 3, md: 4 },
            px: { xs: 2, md: 4 },
            pb: { xs: 2, md: 3 },
            maxWidth: 1200,
            width: '100%',
            mx: 'auto',
          }}
        >
          <Outlet context={{ refreshKey } satisfies AppOutletContext} />
        </Box>
      </Box>
      <SettingsDialog
        open={settingsOpen}
        onClose={() => setSettingsOpen(false)}
        onSaved={() => setRefreshKey((k) => k + 1)}
      />
    </Box>
  );
};

export default AppLayout;
